import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

import { AuthService } from '../../../common/auth/auth.service';
import { AbstractLoginAdaptor } from '../../../common/auth/login/abstract-login.adaptor';
import { WrapFormGroup } from '../../../common/form/abstract-form.adaptor';
import { normalizePhoneAU } from '../../../common/validators/phone-au.validator';

type LoginMethod = 'password' | 'email' | 'phone';

export interface BaseLoginFormData {
  method: LoginMethod;
  noRedirect?: boolean;
}

export interface LoginFormDataEmail extends BaseLoginFormData {
  email: string;
}

export interface LoginFormDataPhone extends BaseLoginFormData {
  phone: string;
}

export interface LoginFormDataEmailPassword extends LoginFormDataEmail {
  password: string;
}

export type LoginFormDataAll = LoginFormDataEmail & LoginFormDataPhone & LoginFormDataEmailPassword;
export type LoginFormData = LoginFormDataEmail | LoginFormDataPhone | LoginFormDataEmailPassword;

interface LoginResponse {
  jwt: string;
}

const URLs: Record<LoginMethod, string> = {
  password: '/accounts/login',
  email: '/accounts/email_logins',
  phone: '/accounts/phone_logins',
};

@Injectable()
export class LoginAdaptor extends AbstractLoginAdaptor<LoginFormData, LoginResponse> {
  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private navCtrl = inject(NavController);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override onRequest({ method, noRedirect, ...formData }: LoginFormData) {
    if ('phone' in formData) {
      formData.phone = normalizePhoneAU(formData.phone);
    }
    return this.http.post<LoginResponse>(URLs[method], {
      auth: { ...formData },
    });
  }
  override async onSuccess({ method, email, phone, noRedirect }: LoginFormDataAll, res: LoginResponse) {
    if (method === 'password') {
      this.auth.setToken(res.jwt);
      this.navCtrl.navigateRoot(['dashboard']);
    } else if (!noRedirect) {
      this.navCtrl.navigateRoot(['magic-link', 'login', method], { queryParams: { email, phone } });
    }
  }

  override onError(formData: LoginFormData, formGroup: WrapFormGroup<LoginFormData>) {
    // When resend fails, the form can't be submit again with error state.
    /* istanbul ignore next */
    if (formData.noRedirect) {
      formGroup.reset();
    }
  }
}
